import type { ProviderManifest } from '../../types';

export const platformaiManifest: ProviderManifest = {
  id: 'platformai',
  label: 'PlatformAI (GovTech)',
  shortLabel: 'PlatformAI',
  vendor: 'GovTech Platform AI — Audio (Azure Fast Transcription)',
  capabilities: { tts: false, stt: true },
  transport: { stt: 'rest-job' },
  // `tts: []` rather than null: null reads as "every language", and this provider
  // has no TTS at all. capabilities.tts gates it first either way, but the array
  // says what is true.
  //
  // Every app LangCode maps to a real Azure Fast Transcription locale (see
  // locales.ts), so there is no reason to make the resolver divert to another
  // provider. Per-language risk is carried by a warning instead, which is louder
  // than a silent fallback.
  languages: {
    tts: [],
    stt: ['en', 'bn', 'my', 'ta', 'hi', 'cn', 'zh', 'ml', 'te'],
  },
  // The point of the proxy routes: the key is RUNTIME-only server env, reachable
  // only from /api/speech/platformai/*. Unlike cambai and qwen, nothing leaks.
  exposesKeyToClient: false,
  experimental: true,
  notes:
    'Transcribes after you stop recording — no live transcript, and a few seconds of '
    + 'processing per turn. Bengali runs on the Indian model (bn-IN); there is no bn-BD. '
    + 'Audio is proxied through this app so the API key stays server-side.',
};
